"use client"
import type React from "react"
import { motion } from "framer-motion"
import { cn } from "@/shared/components/molecules/cn"

const slideUp = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
}

export const TextInput: React.FC<{
  label: string
  name: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  type?: string
  required?: boolean
  placeholder?: string
  isTextarea?: boolean
  customClassName?: string
}> = ({ label, name, value, onChange, type = "text", required, placeholder, isTextarea, customClassName }) => (
  <motion.div variants={slideUp} className="flex flex-col space-y-1 w-full">
    <label className="text-gray-700 font-medium text-sm">{label}</label>
    {isTextarea ? (
      <motion.textarea
        whileFocus={{ borderColor: "#333333" }}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={cn(
          "p-2 border border-gray-200 rounded-md focus:border-gray-700 transition-all duration-200 text-sm w-full min-h-[80px]",
          customClassName,
        )}
      />
    ) : (
      <motion.input
        whileFocus={{ borderColor: "#333333" }}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        className={cn(
          "p-2 border border-gray-200 rounded-md focus:border-gray-700 transition-all duration-200 text-sm w-full",
          customClassName,
        )}
      />
    )}
  </motion.div>
)
